module.exports = __webpack_public_path__ + "img/index_1.16f1b309.png";